import SalaryProject from './views/salary-project.c';
export default SalaryProject;
